'use client';

import type { StoreApi, UseBoundStore } from 'zustand';
import { createTrackedStore } from '@/lib/dev/zustand-registry';

interface SupportState {
  request: number;
  status: 'idle' | 'loading' | 'ready' | 'error';
}

// Shared UI intent connects the footer, menus and launcher to one messenger.
export const useSupportStore: UseBoundStore<StoreApi<SupportState>> =
  createTrackedStore<SupportState>('useSupportStore')(() => ({ request: 0, status: 'idle' }));

export function openSupport(): void {
  const { request, status } = useSupportStore.getState();
  if (status === 'loading') return;
  useSupportStore.setState({ request: request + 1, status: 'loading' });
}
